import { render, staticRenderFns } from "./afterSalesDocument.vue?vue&type=template&id=b838c15e&scoped=true"
import script from "./afterSalesDocument.vue?vue&type=script&lang=js"
export * from "./afterSalesDocument.vue?vue&type=script&lang=js"
import style0 from "./afterSalesDocument.vue?vue&type=style&index=0&id=b838c15e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b838c15e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b838c15e')) {
      api.createRecord('b838c15e', component.options)
    } else {
      api.reload('b838c15e', component.options)
    }
    module.hot.accept("./afterSalesDocument.vue?vue&type=template&id=b838c15e&scoped=true", function () {
      api.rerender('b838c15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/afterSalesDocument.vue"
export default component.exports